

import './dashboard.component.js';
import './dashboard.controller.js';
import './dashboard.data.js';
import './_dashboard.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.dashboard', {
    url: '/dashboard',
    cache: false,
    views: {
      '@': {
        component: 'inkDashboard'
      }
    },
    resolve: {
      $title: (() => 'Today'),
      dashboardData: function(
        DashboardData,
        ShopHours,
        ScheduleUtilFactory,
        moment,
        Session
      ) {
        let startOfDay;
        let endOfDay;
        if (Session.activeState.role === 'operator') {
          return ShopHours.get(Session.activeState.association.shop.id)
          .then(function(hours) {
            let shopHours =
            ScheduleUtilFactory.getShopTimes(hours.all, moment());
            startOfDay = shopHours.earliest.start;
            endOfDay = shopHours.latest.end;
            return DashboardData.refresh(startOfDay, endOfDay);
          });
        }
        startOfDay = moment().startOf('day');
        endOfDay = moment().endOf('day');
        return DashboardData.refresh(startOfDay, endOfDay);
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    },
    onEnter: function(Session, Events) {
      if (Session.activeState.role === 'artist') {
        Events.artistStatsOpen = true;
      }
    },
    onExit: function(DashboardData, Events) {
      DashboardData.reset();
      if (Events.artistStatsOpen) {
        Events.artistStatsOpen = false;
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/dashboard/index.js